<ng-container>
  <div class="loading">
    <mat-progress-spinner class="loading-spinner" [diameter]="250" mode="indeterminate" color="primary">
    </mat-progress-spinner>
    <div class="loading-text"><h1>Logging in...</h1></div>
  </div>
</ng-container>
